// extracted by mini-css-extract-plugin
export default {"header":"eO","container":"fO","accordeonitem":"gO","itemsticky":"hO","itemopen":"iO","open":"jO","productname":"kO","productinfo":"lO","flavorstext":"mO","invalidlimit":"nO","limit":"oO","scrollUpAccordion":"pO","wrapper":"qO"};
    if(module.hot) {
      // 1713211522640
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  